import { Play } from "lucide-react";

const formatDate = (iso) => {
  if (!iso) return "Watch";
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return "Watch";
  }
};

export const VideoCard = ({ video, large = false, vertical = false, testid }) => {
  const href = video.url || video.youtube_url || "#";
  const meta = video.category ? video.category : (video.views || video.published_text || formatDate(video.published));

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className="group relative block overflow-hidden border border-white/10 bg-ink-2 transition-colors duration-500 hover:border-brand"
    >
      <div className={`relative overflow-hidden ${vertical ? "aspect-[9/16]" : "aspect-video"}`}>
        <img
          src={video.thumbnail}
          alt={video.title}
          loading="lazy"
          onError={(e) => {
            if (video.id && !e.currentTarget.dataset.fbk) {
              e.currentTarget.dataset.fbk = "1";
              e.currentTarget.src = `https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`;
            }
          }}
          className="h-full w-full object-cover contrast-125 saturate-[0.85] transition-transform duration-700 ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
        <div className="absolute inset-0 grid place-items-center">
          <span className="grid h-14 w-14 place-items-center rounded-full border border-white/40 bg-black/40 backdrop-blur-md transition-all duration-500 group-hover:scale-110 group-hover:border-brand-accent group-hover:bg-brand-accent group-hover:text-ink">
            <Play className="ml-0.5 h-5 w-5 fill-current" />
          </span>
        </div>
        {video.duration && (
          <span className="absolute right-3 top-3 bg-black/70 px-2.5 py-1 font-mono text-[11px] tracking-widest text-white/90 backdrop-blur-sm">
            {video.duration}
          </span>
        )}
      </div>
      <div className="p-5">
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-brand-accent">{meta}</p>
        <h3 className={`mt-2 font-display font-extrabold uppercase leading-tight tracking-tight text-white transition-colors duration-300 group-hover:text-brand-accent ${large ? "text-2xl md:text-3xl" : "text-lg"}`}>
          {video.title}
        </h3>
      </div>
    </a>
  );
};
